import { render, staticRenderFns } from "./RouteDetails.vue?vue&type=template&id=4e8e2250&"
import script from "./RouteDetails.vue?vue&type=script&lang=js&"
export * from "./RouteDetails.vue?vue&type=script&lang=js&"
import style0 from "./RouteDetails.vue?vue&type=style&index=0&id=4e8e2250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports